export const defaultSnapOrigin =
  process.env.REACT_APP_SNAP_URL ?? `local:http://localhost:8080`;
